export const SESSION_TIME = 60 * 60 * 1000 // 1 hour session expiry time
